import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import * as echarts from 'echarts';
import { EChartsOption } from 'echarts';
import { BrdsqlService } from '../../services/brdsql.service';
import axios from 'axios';
// import echarts from 'echarts/types/dist/echarts';
import { GlobalConstants, yearTh, yearCr } from 'src/environments/global-constants';

@Component({
  selector: 'app-brdproject',
  templateUrl: './brdproject.component.html',
  styleUrls: ['./brdproject.component.css']
})
export class BrdprojectComponent {

  projectData?: any = []
  projectDetail?: any = []
  chartData?: any = []
  yearCr = yearCr()
  yearTh = yearTh();

  chartOption: any;
  chartid = ''

  constructor(
    private brdsv: BrdsqlService,
  ) {
    this.getProjectData();
    console.log('yearTh ', this.yearTh)
  }

  ngOnInit(): void {
    this.test_echarts();
  }

  async getProjectData() {
    await this.brdsv.getProjectSupport(this.yearCr).subscribe({
      next: (res: any) => {
        console.log('getProjectData res:', res.recordset)
        if (res) {
          this.projectData = res.recordset
          console.log('projectData', this.projectData)
          this.test_echarts();
        }
      }
    })
  }

  async moreProjectDetail(id) {
    // console.log('projectcode :', id)
    this.projectDetail = this.projectData.filter((el: any) => el.projectCode == id);
    console.log('projectDetail :', this.projectDetail)
    if (this.projectDetail) {
      this.projectDetail = this.projectDetail[0]
      await this.data_chart_di('');
    }
  }

  test_echartsX() {

    console.log('test_echarts')

    let data = this.projectData
    let chart;
    console.log('data :', data)

    for (var i = 0; i < data.length; i++) {
      let cname = 'echart-'
      cname = cname + data[i].projectCode
      console.log('chart id: ', cname)
      chart = echarts.init(document.getElementById(cname));

      let option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 1048, name: 'Search Engine' },
              { value: 735, name: 'Direct' },
              { value: 580, name: 'Email' },
              { value: 484, name: 'Union Ads' },
              { value: 300, name: 'Video Ads' }
            ]
          }
        ]
      };
      chart.setOption(option);
    }

  }

  test_echarts() {

    let data: any;
    data = this.projectData.filter((el: any) => el.projectCode == '001')
    data = data[0]
    console.log('data filter: ', data)
    let xdata = this.projectData
    let chart;
    let cname = 'echart-'

    for (var i = 0; i < xdata.length; i++) {

      console.log('loop i :', xdata[i])

      cname = cname + xdata[i].projectCode
      console.log('cname', cname)
      this.chartid = cname
      chart = echarts.init(document.getElementById(cname));

      let option = {
        title: {
          text: 'BRD Project',
          //subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'left',
          orient: 'vertical',
        },
        series: [
          {
            name: 'BRD project',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              position: 'center',
              fontSize: 16,
              formatter: function (params) {
                return params.value
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true
            },
            data: [
              { value: data.getmorecane, name: 'ได้อ้อยเพิ่ม' },
              { value: data.projectFm, name: 'ชาวไร่' },
              { value: data.projectPlot, name: 'แปลงอ้อย' },
              { value: data.projectupdate, name: '%งาน' },
              { value: data.projectArea, name: 'พื้นที่' }
            ]
          }
        ]
      };
      chart.setOption(option);

    }




  }


  test() {

    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_cutF_canetype_year?yearID=6667&d=1=1`;
    axios.get(url).then(res => {
      let data = res.data;
      console.log('res data: ', data)
      if (data.length > 0) {
        // this.data_cutF_canetype = data
        // this.data_cutF_sum = data.filter(el => el.datatype2 == "Sum");
        // console.log('data filter : ', this.data_cutF_sum)
        setTimeout(() => {
          this.data_chart_di('canetype');
        }, 1000);
      }
    }).catch(err => { throw (err) })
  }

  data_chart_di(type: string) {

    let chart: any
    chart = echarts.init(document.getElementById('chart-data-test'));

    window.addEventListener('resize', () => {
      chart.resize();
    });

    let data = this.projectDetail
    let data_set = [
      { value: data.projectArea, name: 'พื้นที่' },
      { value: data.projectPlot, name: 'จำนวนแปลง' },
      { value: data.getmorecane, name: 'ได้อ้อยเพิ่ม' },
      { value: data.projectFm, name: 'จำนวนราย' },
      // { value: data.percentupdate, name: '%งาน' },
    ]

    let colors = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'];
    this.shuffleArray(colors);

    console.log('data_set:', data_set);

    const option = {
      color: colors,
      title: {
        text: 'Project: ' + data.projectName,
        // subtext: 'Fake Data',
        left: 'left'
      },
      tooltip: {
        trigger: 'item'
      },
      legend: {
        /*top: 'bottom',
        left: 'center'*/
        top: '8%',
        orient: 'vertical',
        left: 'right'
      },
      series: [
        {
          type: 'pie',
          radius: [0, '30%'],
          label: {
            position: 'center',
            fontSize: 16,
            formatter: function (params) {
              return params.value + '%'
            },
          },
          data: [
            { value: data.projectupdate, name: '%งาน' },
          ]
        },
        {
          name: 'Test',
          type: 'pie',
          radius: ['35%', '65%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            position: 'outer',
            alignTo: 'none',
            backgroundColor: '#F6F8F1',
            borderColor: '#8C8D8S',
            borderRadius: 1,
            formatter: function (params) {
              return params.name + '\n ' + params.value.toLocaleString('th-TH');
            },
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 18,
              fontWeight: 'bold'
            }
          },
          data: data_set
        }
      ]
    };

    chart.setOption(option);

  }

  reset(data) {
    for (var i = 0; i < data.length; i++) {
      const chartContainer = document.getElementById(data[i]);
      const myChart = echarts.init(chartContainer);
      if (myChart) {
        myChart.dispose();
      }
    }
    //console.log('data_all_p:', data);
  }

  shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      // Swap elements
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

  // ngOnChanges() {
  //   console.log('ngOnChanges ')
  // }

  // ngDoCheck() {
  //   console.log('ngOnChanges ')
  // }

  // ngAfterContentInit() {
  //   console.log('ngAfterContentInit ')
  // }

  // ngAfterContentChecked() {
  //   console.log('ngAfterContentChecked ')
  // }

  // ngAfterViewInit() {
  //   console.log('ngAfterViewInit ')
  // }

  // ngAfterViewChecked() {
  //   console.log('ngAfterViewChecked ')
  // }

  // ngOnDestroy() {
  //   console.log('ngOnDestroy ')
  // }

  /*
    // Doughnut
    public doughnutChartLabels: string[] = ['แปลงอ้อย', 'ชาวไร่', 'ได้อ้อยเพิ่ม'];
    public doughnutChartData: number[] = [1350, 450, 25000];
    public doughnutChartType: string = 'doughnut';
    radius: [0, '30%'],
  
    public chartClicked(e: any): void {
      console.log(e);
    }
  
    public chartHovered(e: any): void {
      console.log(e);
    }
  */

}
